// extracted by mini-css-extract-plugin
module.exports = {"description":"test-description_description__2ygzH"};